import React from 'react';

import { Bell, BellDot } from 'lucide-react';

import { IconButton } from '@/components/ui/custom/IconButton';

import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '@/components/ui/popover';

import { useAnnouncements } from './useAnnouncements';
import { AnnouncementList } from './AnnouncementList';

const AnnouncementButton = () => {
	const { announcements, hasUnread, markAsRead } = useAnnouncements();

	return (
		<div>
			<Popover>
				<PopoverTrigger>
					<IconButton
						aria-label="announcements"
						toolTipTitle="Announcements"
						onClick={markAsRead}
					>
						{hasUnread ? (
							<BellDot className="size-4" />
						) : (
							<Bell className="size-4" />
						)}
					</IconButton>
				</PopoverTrigger>
				<PopoverContent
					align="end"
					className="w-[600px] max-h-[550px] overflow-auto"
				>
					<AnnouncementList announcements={announcements} />
				</PopoverContent>
			</Popover>
		</div>
	);
};

export default AnnouncementButton;
